export default __webpack_public_path__ + "static/assets/c999158bc76ef31c114675aacb6b7774.svg";